export const ANALYTICS_COOKIE = "ot-ga"
export const GA_MEASUREMENT_ID =
  process.env.GATSBY_GOOGLE_ANALYTICS_ID || "G-44WV9YWTPG"

const SCRIPT_ID = "other-things-google-analytics"
const INITIALIZED_FLAG = "__otherThingsGoogleAnalyticsInitialized"

export function hasAnalyticsConsent() {
  if (typeof document === "undefined") return false

  return document.cookie
    .split(";")
    .some(cookie => cookie.trim() === `${ANALYTICS_COOKIE}=true`)
}

export function initializeAnalytics() {
  if (typeof window === "undefined" || !hasAnalyticsConsent()) return false

  window[`ga-disable-${GA_MEASUREMENT_ID}`] = false
  window.dataLayer = window.dataLayer || []
  window.gtag =
    window.gtag ||
    function gtag() {
      window.dataLayer.push(arguments)
    }

  if (!document.getElementById(SCRIPT_ID)) {
    const script = document.createElement("script")
    script.id = SCRIPT_ID
    script.async = true
    script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`
    document.head.appendChild(script)
  }

  if (!window[INITIALIZED_FLAG]) {
    window.gtag("js", new Date())
    window.gtag("config", GA_MEASUREMENT_ID, {
      allow_ad_personalization_signals: false,
      allow_google_signals: false,
      anonymize_ip: true,
      send_page_view: false,
    })
    window[INITIALIZED_FLAG] = true
  }

  return true
}

export function trackPageView(location = window.location) {
  if (!initializeAnalytics()) return false

  window.gtag("event", "page_view", {
    page_location: location.href,
    page_path: `${location.pathname}${location.search}${location.hash}`,
    page_title: document.title,
  })

  return true
}

export function disableAnalytics() {
  if (typeof window === "undefined") return

  window[`ga-disable-${GA_MEASUREMENT_ID}`] = true
}
